<template>
  <div class="signup -p-relative" :class="{ '-small': small }">
    <transition-group name="crossfade" tag="div">
      <div v-if="!submitted || !showConfirmation" :key="'form'">
        <component
          :is="includeForm ? 'form' : 'div'"
          ref="form"
          class="signup-form"
          v-on="submit.prevent"
        >
          <InputFieldV2
            :id="inputName || 'signup-form'"
            class="signup-field"
            :value="email"
            @change="$emit('change', $event)"
            @focus="$emit('focus')"
            :block="true"
            :disabled="locked"
            :placeholder="
              insertString('Global', 'EmailPlaceholder') ||
              'john.doe@example.com'
            "
            :error="error"
            :errorMessage="errorMsg"
            :aria-errormessage="`Error: ${errorMsg}`"
            tabindex="0"
            aria-label="Enter your email address to sign up for our newsletter"
          />
          <ButtonComponent
            class="signup-submit"
            @click="submit()"
            :theme="'main'"
            :forceTextColor="buttonStyle.text"
            :overrideThemeColor="buttonStyle.background"
            :block="true"
            :loading="loading"
            :small="small"
            :disabledText="disabledText"
            :disabled="disabled || locked"
            tabindex="0"
            :text="insertString('Global', 'Submit') || 'Submit'"
          />
        </component>
        <div
          v-if="footnote"
          class="font-responsive-small m-t-9"
          v-html="footnote"
        />
        <slot />
      </div>
      <div
        v-else-if="showConfirmation"
        v-html="confirmationMessage"
        :key="'confirmation'"
        role="alert"
      />
    </transition-group>
  </div>
</template>
<script>
import InputFieldV2 from '@/Scripts/components/shared/InputFieldV2/InputFieldV2.vue';
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';

export default {
  name: 'Signup',
  components: {
    InputFieldV2,
    ButtonComponent
  },
  model: {
    prop: 'email',
    event: 'change'
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    footnote: String,
    confirmation: {
      type: String,
      default: ''
    },
    showConfirmation: {
      type: Boolean,
      default: true
    },
    small: Boolean,
    buttonStyle: {
      type: Object,
      default () {
        return {
          text: '',
          background: ''
        };
      }
    },
    includeForm: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    disabledText: String,
    locked: Boolean,
    inputName: String,
    loading: Boolean
  },
  data () {
    return {
      error: false,
      submitted: false,
      errorMsg: this.insertString('Global', 'EmailErrorFormat')
    };
  },
  computed: {
    confirmationMessage () {
      return this.confirmation || this.insertString('Global', 'SignupSuccess');
    }
  },
  methods: {
    submit () {
      if (this.valid()) {
        this.submitted = true;
        if (!this.loading) {
          this.$emit('submit');
        }
      } else {
        this.error = true;
      }
    },
    valid () {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email) === false || this.email === '') {
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";
.signup {
  a {
    color: currentColor;
    text-decoration: underline;
  }
  &-form {
    display: flex;
    position: relative;
  }
  &-field {
    width: 100%;
    label {
      display: none;
    }
    div > input {
      height: 50px !important;
      border-radius: 8px;
    }
    span.error {
      text-align: right;
    }
  }
  &-submit {
    position: absolute;
    top: 3px;
    right: 3px;
    z-index: 10;
  }
  &.-small {
    height: rem(36px);
    .signup-field div > input {
      @include font-spacing-responsive(body);
      height: rem(36px) !important;
      border-radius: 8px;
      font-size: rem(13px);
      padding: 12px;
    }
  }

  .crossfade-enter {
    opacity: 1;
  }
  .crossfade-leave-to {
    opacity: 0;
  }
  .crossfade-leave-active {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 10;
    transition: opacity 0.33s;
  }
  .crossfade-enter-active {
    opacity: 0;
    transition: opacity 0.33s;
  }
}
</style>
